<template>
	<div class="tabs">
		<div class="pt-16" v-if="$auth.hasPermi('system:order:editOrder') && attribution_abnormal_num">
			<Tip type="warning">
				<span slot="content" class="yx-color-text-primary ml-10 font-h4-regular">
					请注意：您有
					<span class="yx-color-warning">{{ attribution_abnormal_num }}</span>
					笔订单员工提成总额超过到手服务费，建议筛选【异常订单】后，使用【修改订单归属/修改查询订单归属】进行修改。
				</span>
			</Tip>
		</div>
		<Panel :contentPaddingTop="16">
			<div class="price-wrap">
				<div class="item">
					<div class="fz-14 grayColor">总订单金额</div>
					<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="orderStatResult.loading"></i>
					<div class="num line-height-1" v-else>{{ statistics.total_pay_amount | formatEmpty | formatPrice }}</div>
				</div>
				<div class="item">
					<div class="fz-14 grayColor">总订单量</div>
					<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="orderStatResult.loading"></i>
					<div class="num line-height-1" v-else>{{ statistics.order_count | formatEmpty }}</div>
				</div>
				<template v-if="serviceIn">
					<div class="item" v-if="$auth.hasPermi('system:Order:Service-fee-income')">
						<div class="fz-14 grayColor">预估服务费收入</div>
						<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="estimatedLoading"></i>
						<div v-else class="num line-height-1 primary-color">
							{{ statistics.income_estimated_commission | formatEmpty | formatPrice }}
						</div>
					</div>
					<div class="item">
						<div class="fz-14 grayColor">达人商务未认领金额</div>
						<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="drUnbindLoading"></i>
						<div class="num line-height-1 primary-color" v-else>
							{{ statistics.talent_unbind_total_fee | formatEmpty | formatPrice }}
						</div>
					</div>
					<div class="item">
						<div class="fz-14 grayColor">招商运营未认领金额</div>
						<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="zsUnbindLoading"></i>
						<div class="num line-height-1 primary-color" v-else>
							{{ statistics.bd_unbind_total_fee | formatEmpty | formatPrice }}
						</div>
					</div>
				</template>
				<div v-else-if="$auth.hasPermi('system:Order:Service-fee-disburse')" class="item">
					<div class="fz-14 grayColor">预估服务费支出</div>
					<i class="el-icon-loading fz-24 mt-12 yx-color-primary" v-if="estimatedLoading"></i>
					<div v-else class="num line-height-1">{{ statistics.disburse_estimated_commission | formatEmpty | formatPrice }}</div>
				</div>

				<div class="item" v-if="isDrPartnerDataView || isAllDataView">
					<div class="fz-14 grayColor">达人商务提成</div>
					<div class="num line-height-1 primary-color">
						{{ statistics.talent_partner_commission_fee | formatPrice }}
					</div>
				</div>
				<div class="item" v-if="isShopPartnerDataView || isAllDataView">
					<div class="fz-14 grayColor">招商运营提成</div>
					<div class="num line-height-1 primary-color">
						{{ statistics.bd_partner_commission_fee | formatPrice }}
					</div>
				</div>
			</div>
		</Panel>
		<div class="flex flex-align-center flex-just-between pt-16 pb-16">
			<template v-if="$auth.hasPermi('system:order:editOrder') && serviceIn">
				<div class="ml-16 mr-18">
					<el-checkbox @change="checkeFun" v-model="allChecked">当页全选</el-checkbox>
					<affiliation-button class="ml-24" :selectArr="selectionShopArr" @onSubmit="search"></affiliation-button>
				</div>
			</template>
			<div class="flex flex-align-center">
				<export-list
					v-if="$auth.hasPermi('system:Order:exportOrder')"
					ref="exportList"
					:routerPath="routerPath"
					:platformId="platformId"
					:exportInterface="exportInterface"
					:exportDialog="exportDialog"
				></export-list>
			</div>
		</div>
		<multi-table
			ref="multiTable"
			:selectionChange="selectionChange"
			:columns="filterColumns"
			@gePartnerList="gePartnerList"
			:list="list"
			:options="options"
			:total="total"
			:layout="layout"
			v-loading="loading"
		>
			<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			<span class="totalnums" slot="total">{{ `共 ${totalFake} 条` }}</span>
		</multi-table>
		<affiliation-dialog
			ref="affiliationDialog"
			@refresh="refresh"
			:platformId="platformId"
			:search-params="searchBelongParams"
			:result="orderStatResult"
			:paramsTextArr="paramsTextArr"
		></affiliation-dialog>
		<AddSpidDialog ref="AddSpidDialog" @refresh="refresh"></AddSpidDialog>
	</div>
</template>
<script>
import { getColumns } from '../columns';
import { mapState, mapGetters } from 'vuex';
import {
	orderList,
	orderStatistics,
	exportOrder,
	getAbnormalTotal,
	talentStatistics,
	bdStatistics,
	getSpOrderList,
	getSpOrderStatistics,
	exportOrderSp,
} from '@/api/shopManage';

import AffiliationDialog from '../components/affiliationDialog';
import AffiliationButton from './affiliationButton';
import { drRoleType, zsRoleType } from '@/utils/dataMap';
import empty from '@/views/common/empty/index.vue';
import exportList from '@/views/common/exportList';
import { formatterDate } from '@/utils/common';
import { startOfDay, endOfDay, parseISO } from 'date-fns';
import dataMap from '../../../../../utils/dataMap';
import AddSpidDialog from '@/components/business/addSpidDialog';
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
		tabName: {
			type: [String, Number],
			default: '',
		},
	},
	components: {
		empty,
		exportList,
		AffiliationDialog,
		AffiliationButton,
		AddSpidDialog,
	},
	provide() {
		return {
			injectSetSpid: this.showSpidDialog,
		};
	},
	data() {
		return {
			statistics: {
				order_count: '',
				total_pay_amount: '',
				partner_commission_fee: '',
				talent_unbind_total_fee: '',
				bd_unbind_total_fee: '',
				income_estimated_commission: '', //预估服务费收入
				disburse_estimated_commission: '', //预估服务费支出
				bd_partner_commission_fee: '',
				talent_partner_commission_fee: '',
			},
			total: 0,
			totalFake: 0,
			selectionShopArr: [],
			params: {
				page_index: 1,
				page_size: 10,
			},
			allChecked: false,
			list: [],
			options: {
				selectable: true,
			},
			isSearch: false,
			routerPath: '/order/record',
			attribution_abnormal_num: 0,
			loading: false,
			orderLoading: false,
			drUnbindLoading: false,
			zsUnbindLoading: false,
			estimatedLoading: false,
			layout: 'slot,sizes, prev, pager, next',
			orderStatResult: {
				order_count: '', // 总订单量
				total_pay_amount: '', // 总支付金额
				loading: false, // 订单统计loading状态
				status: '', // 订单统计接口状态
			},
			paramsTextArr: [],
			searchBelongParams: {}, // 查询归属参数
		};
	},
	computed: {
		...mapGetters(['isAllDataScope', 'isDrPartnerDataView', 'isShopPartnerDataView', 'isAllDataView']),
		...mapState(['vuex_userInfo']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		serviceIn() {
			return this.tabName === '0';
		},
		filterColumns() {
			let filterArr = getColumns(this).filter(item => item.isShow);
			return filterArr;
		},
		drName() {
			return drRoleType.name;
		},
		zsName() {
			return zsRoleType.name;
		},
	},
	created() {
		const { from_time, to_time, order_status } = this.$route.query;
		if (from_time) {
			this.params.pay_time_start = Number(from_time);
			this.params.pay_time_end = Number(to_time);
		} else {
			this.payTime(formatterDate(0));
		}
		if (order_status) this.params.order_status = order_status;
		this.params.platform_id = this.platformId;
		if (this.tabName === '1') {
			//colonel_type抖音达人为2团长为1, 快手达人为1团长为2
			this.params.colonel_type = this.platformId;
		}
		this.getShopGroupList();
		this.getStatistics();
		this.getAbnormalTotal();
	},
	methods: {
		showSpidDialog(row) {
			this.$refs.AddSpidDialog.show(row);
		},
		getParams() {
			if (this.$isSp()) {
				const {
					product_name,
					third_product_id,
					order_id,
					order_status,
					pay_time_start,
					pay_time_end,
					settle_time_start,
					settle_time_end,
					talent_user_id,
					bd_user_ids,
					authority_id,
					anchor_name,
					anchorAccount,
					shop_id,
					shop_name,
					attribution_status,
					sec_colonel_name,
					colonel_type,
					page_index,
					page_size,
				} = this.params;
				console.log('this.$isSp()', this.params, 123123);
				let spParam = {
					secColonelName: sec_colonel_name, //出单二级团
					colonelType: colonel_type,
					productName: product_name,
					thirdProductId: third_product_id,
					parentOrderId: order_id,
					orderStatus: order_status,
					payTimeStart: pay_time_start,
					payTimeEnd: pay_time_end,
					settleTimeStart: settle_time_start,
					settleTimeEnd: settle_time_end,
					talentUserIds: +talent_user_id > 0 ? [talent_user_id] : undefined,
					bdUserIds: bd_user_ids?.[0] == 0 ? undefined : bd_user_ids,
					institutionId: authority_id,
					shopId: shop_id,
					shopName: shop_name,
					anchorName: anchor_name,
					anchorAccount: anchorAccount,
					attributionStatus: attribution_status,
					talentUnClaimed: talent_user_id === 0 ? 1 : undefined,
					bdUnClaimed: bd_user_ids?.[0] === 0 ? 1 : undefined,
					pageIndex: page_index,
					pageSize: page_size,
				};
				if (this.tabName == 1) {
					spParam.colonelType = '2'; //视频号，服务费支出tab
				}
				return {
					...spParam,
				};
			} else {
				return this.params;
			}
		},
		adaptList(list) {
			if (this.$isSp()) {
				return list.map(item => {
					const {
						productPic,
						productName,
						thirdProductId,
						shopName,
						shopId,
						parentOrderId,
						productId,
						anchorName,
						anchorAccount,
						authorityName,
						authorityId,
						payTimeText,
						settleTimeText,
						orderStatusText,
						orderPayAmount,
						partnerCommissionRate,
						partnerEstimatedCommission,
						partnerRealCommission,
						bdUserName,
						bdCommissionRate,
						bdCommissionAmount,
						bdRealCommissionAmount,
						talentCommissionRate,
						talentCommissionAmount,
						talentRealCommissionAmount,
						talentBelongTypeText,
						talentBelongTimeText,
						bdBelongTypeText,
						bdBelongTimeText,
						productUrl,
						cooperateId,
						colonelType,
						colonelTypeDesc,
						bdDelete,
						bdUseStatus,
						talentDelete,
						talentUseStatus,
						attributionStatus,
						talentUserName,
						subNickName,
						subAppid,
						orderId,
						actuallyEstimatedCommission,
						actuallyRealCommission,
						disburseCommissionRate,
						disburseEstimatedCommission,
						disburseRealCommission,
						openFinderIds,
						...rest
					} = item;
					return {
						...rest,
						sub_nick_name: subNickName,
						sub_appid: subAppid,
						product_pic: productPic,
						platform_id: this.platformId,
						product_name: productName,
						third_product_id: thirdProductId,
						shop_name: shopName,
						shop_id: shopId,
						order_id: orderId,
						parentOrderId,
						product_id: productId,
						cooperate_id: cooperateId,
						product_url: productUrl,
						anchor_name: anchorName,
						anchor_account: openFinderIds,
						colonel_type: colonelType,
						colonel_type_desc: colonelTypeDesc,
						partner_name: talentUserName,
						institution_name: authorityName,
						authority_id: authorityId,
						pay_success_time: payTimeText,
						settle_time: settleTimeText,
						attribution_status: attributionStatus,
						order_status_desc: orderStatusText || '-',
						total_pay_amount: orderPayAmount,
						income_commission_rate: partnerCommissionRate,
						income_estimated_commission: partnerEstimatedCommission,
						income_real_commission: partnerRealCommission,
						bd_partner_name: bdUserName,
						bd_partner_rate: bdCommissionRate,
						bd_partner_commission_fee: bdCommissionAmount,
						bd_partner_real_commission_fee: bdRealCommissionAmount,
						bd_partner_info: {
							deleted: bdDelete,
							use_status: bdUseStatus,
						},
						talent_info: {
							deleted: talentDelete,
							use_status: talentUseStatus,
						},
						partner_rate: talentCommissionRate,
						partner_commission_fee: talentCommissionAmount,
						partner_real_commission_fee: talentRealCommissionAmount,
						talent_belong_text: talentBelongTypeText,
						talent_belong_time_text: talentBelongTimeText,
						bd_belong_text: bdBelongTypeText,
						bd_belong_time_text: bdBelongTimeText,
						hideCopyLink: true,
						actually_estimated_commission: actuallyEstimatedCommission,
						actually_real_commission: actuallyRealCommission,
						disburse_commission_rate: disburseCommissionRate,
						disburse_estimated_commission: disburseEstimatedCommission,
						disburse_real_commission: disburseRealCommission,
					};
				});
			}
			return list.map(item => {
				return {
					...item,
					hideCopyLink: true,
				};
			});
		},
		//获取订单列表
		async getShopGroupList(value) {
			this.isSearch = Boolean(value);
			this.loading = true;
			const apiMap = {
				[dataMap.PLATFORM_DY.value]: orderList,
				[dataMap.PLATFORM_KS.value]: orderList,
				[dataMap.PLATFORM_SP.value]: getSpOrderList,
			};
			this.searchBelongParams = this.getParams();
			const { code, data } = await apiMap[this.platformId](this.searchBelongParams);
			if (code == 0) {
				this.list = this.adaptList(data.list);
				// 查询列表数据为0，并且进行全量修改归属操作时展示提示信息
				if (!data.list.length && this.$refs.affiliationDialog.isDialogShow()) {
					this.$message.error('查询订单数据为0条，请调整查询条件后重试');
				}
				if (this.$isSp()) {
					data.page.item_total = data.page.itemTotal;
				}
				this.totalFake = data.page.item_total;
				if (this.totalFake > 10000) {
					this.total = 10000;
				} else {
					this.total = data.page.item_total;
				}
			}
			this.loading = false;
		},
		//未认领订单金额
		// 未确认
		async getStatistics() {
			this.getOrderStatistics();
			if (this.$isSp()) {
				return;
			}
			// 全部数据权限 触发
			this.isAllDataScope && this.getDrUnbindStatistics();
			this.isAllDataScope && this.getZsUnbindStatistics();
		},
		// 订单统计数据+达人商务未认领金额数据+招商运营未认领金额数据(合并)
		async getOrderStatistics() {
			this.orderStatResult.loading = true;
			this.orderLoading = true;
			this.estimatedLoading = true;
			try {
				const apiMap = {
					[dataMap.PLATFORM_DY.value]: orderStatistics,
					[dataMap.PLATFORM_KS.value]: orderStatistics,
					[dataMap.PLATFORM_SP.value]: getSpOrderStatistics,
				};
				let {
					code,
					data: {
						order_count,
						total_pay_amount,
						partner_commission_fee,
						income_estimated_commission,
						disburse_estimated_commission,
						talent_partner_commission_fee,
						bd_partner_commission_fee,
						totalAmount,
						totalOrder,
						disburseEstimatedCommission, //预估服务费支出
						partnerEstimatedCommission,
						talentUnClaimAmount,
						bdUnClaimAmount,
						talentCommissionAmount,
						bdCommissionAmount,
					},
				} = await apiMap[this.platformId](this.getParams());
				if (code === 0) {
					if (this.$isSp()) {
						order_count = totalOrder;
						total_pay_amount = totalAmount;
						partner_commission_fee = partnerEstimatedCommission;
						income_estimated_commission = partnerEstimatedCommission;
						disburse_estimated_commission = disburseEstimatedCommission;
						talent_partner_commission_fee = talentCommissionAmount;
						bd_partner_commission_fee = bdCommissionAmount;
						this.statistics.bd_unbind_total_fee = bdUnClaimAmount;
						this.statistics.talent_unbind_total_fee = talentUnClaimAmount;
					}
					this.statistics.order_count = this.orderStatResult.order_count = order_count;
					this.statistics.total_pay_amount = this.orderStatResult.total_pay_amount = total_pay_amount;
					this.statistics.partner_commission_fee = partner_commission_fee;
					this.statistics.income_estimated_commission = income_estimated_commission;
					this.statistics.disburse_estimated_commission = disburse_estimated_commission;
					this.statistics.talent_partner_commission_fee = talent_partner_commission_fee;
					this.statistics.bd_partner_commission_fee = bd_partner_commission_fee;
					this.orderStatResult.loading = false;
					this.orderStatResult.status = 'success';
					this.orderLoading = false;
					this.estimatedLoading = false;
				} else {
					this.statistics.order_count = this.orderStatResult.order_count = '';
					this.statistics.total_pay_amount = this.orderStatResult.total_pay_amount = '';
					this.statistics.partner_commission_fee = '';
					this.statistics.income_estimated_commission = '';
					this.statistics.disburse_estimated_commission = '';
					this.orderStatResult.loading = false;
					this.orderStatResult.status = 'error';
					this.orderLoading = false;
					this.estimatedLoading = false;
				}
			} catch (error) {
				this.statistics.order_count = this.orderStatResult.order_count = '';
				this.statistics.total_pay_amount = this.orderStatResult.total_pay_amount = '';
				this.statistics.partner_commission_fee = '';
				this.statistics.income_estimated_commission = '';
				this.statistics.disburse_estimated_commission = '';
				this.statistics.talent_partner_commission_fee = '';
				this.statistics.bd_partner_commission_fee = '';
				this.orderStatResult.loading = false;
				this.orderStatResult.status = 'error';
				this.$message.error(error.message);
				this.orderLoading = false;
				this.estimatedLoading = false;
			}
		},
		// 达人商务未认领金额数据
		async getDrUnbindStatistics() {
			this.drUnbindLoading = true;
			try {
				const {
					code,
					data: { talent_unbind_total_fee },
				} = await talentStatistics(this.params);
				if (code === 0) {
					this.statistics.talent_unbind_total_fee = talent_unbind_total_fee;
					this.drUnbindLoading = false;
				} else {
					this.statistics.talent_unbind_total_fee = '';
					this.drUnbindLoading = false;
				}
			} catch (error) {
				this.statistics.talent_unbind_total_fee = '';
				this.drUnbindLoading = false;
				this.$message.error(error.message);
			}
		},
		// 招商运营未认领金额数据
		async getZsUnbindStatistics() {
			this.zsUnbindLoading = true;
			try {
				const {
					code,
					data: { bd_unbind_total_fee },
				} = await bdStatistics(this.params);
				if (code === 0) {
					this.statistics.bd_unbind_total_fee = bd_unbind_total_fee;
					this.zsUnbindLoading = false;
				} else {
					this.statistics.bd_unbind_total_fee = '';
					this.zsUnbindLoading = false;
				}
			} catch (error) {
				this.statistics.bd_unbind_total_fee = '';
				this.zsUnbindLoading = false;
				this.$message.error(error.message);
			}
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			const selectionLength = this.selectionShopArr.length;
			this.allChecked = selectionLength && selectionLength === this.list.length;
		},
		//选中值
		checkeFun(e) {
			this.$refs.multiTable.$refs.baseTable.toggleSelection(this.list, e);
		},
		refresh() {
			const { getShopGroupList, getStatistics, getAbnormalTotal } = this;
			getShopGroupList();
			getStatistics();
			getAbnormalTotal();
		},
		//筛选
		onSubmit(val) {
			this.params = JSON.parse(JSON.stringify(val));
			this.params.page_index = 1;
			this.params.page_size = 10;
			if (this.tabName === '1') {
				this.params.colonel_type = this.platformId;
			} else {
				if (val.colonel_type) {
					this.params.colonel_type = val.colonel_type;
				} else {
					this.params.colonel_type = '';
				}
			}
			this.params.platform_id = this.platformId;
			this.$refs.multiTable.resetPage();
			this.getShopGroupList('1');
			this.getStatistics();
			this.getAbnormalTotal();
		},
		//分页
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getShopGroupList();
		},
		search() {
			this.$refs.search.onSubmit();
		},
		// switch() {
		// 	this.$refs.search.onClear(1);
		// },
		async exportInterface(that) {
			const api = {
				[dataMap.PLATFORM_DY.value]: exportOrder,
				[dataMap.PLATFORM_KS.value]: exportOrder,
				[dataMap.PLATFORM_SP.value]: exportOrderSp,
			};
			const { code } = await api[this.platformId]({ ...this.getParams(), opt_type: 1 });
			if (code === 0) {
				that.$refs.exportDialog.show(this.exportDialog);
			}
		},
		async exportDialog() {
			const { params, tabName, platformId: platform_id, routerPath } = this;
			const { code } = await exportOrder({
				...params,
				action_type: tabName === '0' ? '1' : '2',
				opt_type: 2,
			});
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		payTime(value) {
			const [start, end] = value || [];
			this.params.pay_time_start = start ? Math.trunc(startOfDay(parseISO(start)) / 1000) : '';
			this.params.pay_time_end = end ? Math.trunc(endOfDay(parseISO(end)) / 1000) : '';
		},
		async getAbnormalTotal() {
			const { platformId: platform_id } = this;
			const {
				code,
				data: { attribution_abnormal_num = 0 },
			} = await getAbnormalTotal({ platform_id });
			if (code !== 0) return;
			this.attribution_abnormal_num = attribution_abnormal_num;
		},
		setParamsTextArr(val) {
			this.paramsTextArr = val;
		},
	},
};
</script>
<style lang="less" scoped>
.grayColor {
	color: #86909c;
}
.order {
	border-left: 1px solid #eee;
}

.price-wrap {
	display: flex;
	margin-top: 24px;
	color: #333;
	align-items: center;

	.item {
		flex: 1;
		padding-left: 60px;
		position: relative;

		// &:nth-child(n + 2) {
		// 	border-left: 1px solid #e3e3e3;
		// }

		.num {
			margin-top: 12px;
			font-size: 26px;
			font-weight: bold;
			font-family: DINAlternate-Bold, DINAlternate;
		}
	}
	.item::after {
		content: '';
		position: absolute;
		left: 100%; /* 竖线条的位置在元素的右侧外侧 */
		top: 50%; /* 竖线条的顶部位于元素的中间 */
		transform: translateY(-50%);
		width: 1px;
		height: 12px;
		background-color: #a9aeb8;
	}
	.item:last-child::after {
		width: 0;
	}
}

.totalnums {
	color: #666666;
	font-size: 13px;
	margin-right: 10px;
	font-weight: normal;
}

/deep/.el-pagination {
	.more + .number {
		display: none;
	}
}
</style>
